"use client";
import {
  anchor_default
} from "../../chunk-OQPBJW2X.js";
import "../../chunk-4RZJ54WQ.js";
import "../../chunk-CBJJ6H3K.js";
export {
  anchor_default as default
};
